export const STORAGE_KEYS = {
  TOKEN: 'dpdp_session_token',
  API_KEY: 'dpdp_api_key',
  APP_ID: 'dpdp_app_id',
  ACTIVE_ORG: 'dpdp_active_org_id',
  SETUP_COPIED_KEY: 'dpdp_setup_copied_key',
  ONBOARDING_STEP: 'dpdp_onboarding_step',
  ONBOARDING_COMPLETED: 'dpdp_onboarding_completed',
} as const;

export const DEFAULT_PURPOSES = {
  en: [
    {
      id: 'marketing_emails',
      title: 'Marketing Emails',
      description: 'Receive updates, promotions, and special offers.',
    },
    {
      id: 'analytics',
      title: 'Product Analytics',
      description: 'Allow us to track usage to improve our product.',
    },
  ],
  hi: [
    {
      id: 'marketing_emails',
      title: 'विपणन ईमेल',
      description: 'अपडेट, प्रचार और विशेष प्रस्ताव प्राप्त करें।',
    },
    {
      id: 'analytics',
      title: 'उत्पाद विश्लेषण',
      description: 'हमारे उत्पाद को बेहतर बनाने के लिए उपयोग को ट्रैक करने की अनुमति दें।',
    },
  ],
} as const;
